import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveAttachedDocumentRequestFailure(documentId) {
      const req = getState().find(({ documentId: dId }) => dId === documentId);

      return req ? req.request.isFailure : false;
    },
    isRemoveAttachedDocumentRequestPending(documentId) {
      const req = getState().find(({ documentId: dId }) => dId === documentId);

      return req ? req.request.isPending : false;
    },
    isRemoveAttachedDocumentRequestSuccess(documentId) {
      const req = getState().find(({ documentId: dId }) => dId === documentId);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
